// Meter configuration constants
export const meterUnits = [
  'Gallons × 1',
  'Gallons × 10',
  'Gallons × 100',
  'Gallons × 1000',
  'Acre-Inches × 0.001',
  'Acre-Inches × 0.01',
  'Acre-Inches McCrometer FlowCom',
  'Acre-Feet × 0.001',
  'Acre-Feet McCrometer FlowCom',
  'Unknown'
]

export const meterBrands = [
  'McCrometer',
  'Netafim',
  'Badger Meter',
  'Sensus',
  'Master Meter',
  'GrowSmart',
  'Other'
]

export const GAL_PER_ACRE_INCH = 27154

// McCrometer FlowCom digital meters print a 2-decimal total (e.g. 778.23).
// We auto-place that decimal on entry/display just like the mechanical
// registers, so the field crew only ever types the digits they see.
export const FLOWCOM_DECIMALS = 2

export function formatReadingValue(value, units) {
  if (value === null || value === undefined || value === '') return ''
  if (units?.includes('McCrometer FlowCom')) return parseFloat(value).toFixed(FLOWCOM_DECIMALS)
  if (!units?.includes('× 0.0')) return String(value)
  const match = units.match(/× (0\.0+\d*)/)
  if (!match) return String(value)
  const decimalPlaces = match[1].length - 2
  return parseFloat(value).toFixed(decimalPlaces)
}

export function getDecimalPlaces(units) {
  if (units?.includes('McCrometer FlowCom')) return FLOWCOM_DECIMALS
  if (!units?.includes('× 0.0')) return null
  const match = units.match(/× (0\.0+\d*)/)
  return match ? match[1].length - 2 : null
}

export function formatDecimalInput(rawDigits, decimalPlaces) {
  if (!rawDigits) return ''
  const cleaned = rawDigits.replace(/^0+/, '') || '0'
  const padded = cleaned.padStart(decimalPlaces + 1, '0')
  const whole = padded.slice(0, padded.length - decimalPlaces)
  const frac = padded.slice(padded.length - decimalPlaces)
  return whole + '.' + frac
}

export function getReadingHelperText(units) {
  if (!units) return null
  if (units.includes('× 0.0')) {
    return 'Decimal is auto-placed to match the white and yellow digits on the meter'
  }
  if (units.includes('FlowCom')) {
    return 'Type just the digits from the FlowCom total — the decimal is placed for you (e.g. 77823 → 778.23)'
  }
  if (units === 'Gallons × 1000') {
    return null
  }
  if (units.startsWith('Gallons')) {
    return null
  }
  return null
}
